import { Button } from '@sonnen/web-ui';
import { nextLabelByPath } from '../../constants';
import { useCurrentRoute } from '../../hooks/useCurrentRoute';
import { useOrderFlowNavigation } from '../../hooks/useOrderFlowNavigation';
import { useTranslation } from '../../i18n/i18n';

interface SideCardButtonProps {
  loading?: boolean;
  disabled?: boolean;
}

export const SideCardButton = ({ loading, disabled }: SideCardButtonProps) => {
  const { t } = useTranslation();
  const currentRoute = useCurrentRoute();
  const { navigateNext } = useOrderFlowNavigation();

  const onClick = () => navigateNext?.();

  const labelByPath = nextLabelByPath[currentRoute];

  const label = labelByPath ? t(labelByPath || 'offer.offerBtn') : undefined;

  if (!label || !navigateNext) return false;

  return (
    <Button
      label={label}
      onClick={onClick}
      dataTestId="offer-card-btn"
      loading={loading}
      disabled={disabled}
      expanded
    />
  );
};
